import Cookies from 'js-cookie'

export const authTokenName = process.env.VUE_APP_TOKEN_NAME || 'auth-token'

export function getToken () {
  return Cookies.get(authTokenName)
}

export const baseURL = process.env.VUE_APP_BACKEND_API_ENDPOINT || 'https://elyasmith.atwinta.ru/api'

export const fileManagerURL = process.env.VUE_APP_BACKEND_FILEMANAGER_ENDPOINT || 'https://elyasmith.atwinta.ru/file-manager/'

export const fileManagerTrainerURL = process.env.VUE_APP_BACKEND_FILEMANAGER_TRAINER_ENDPOINT || 'https://elyasmith.atwinta.ru/file-manager/'

// Формирование ссылки для скачивания файла с оригинальным именем
export const downloadOriginalFile = `${baseURL}/download/`
